import { defineStore } from 'pinia';
import { ref } from 'vue';
import * as api from '@/api/security.api';
import { api as axiosInstance } from '@/services/axios.service';
import type { AltchaVerifiedPayload } from '@/models/altcha.model';
import { buildAuthorizationHeaderValue } from '@/utils/security.utils';

export const useSecurityStore = defineStore('security', () => {
    const accessToken = ref<string>();

    function setupReferrer() {
        try {
            const insightReferrer = document.referrer || axiosInstance.defaults.headers.common['Insight-Referrer'];
            axiosInstance.defaults.headers.common['Insight-Referrer'] = insightReferrer;
            console.log('[DEBUG|Referrer] Setting Insight-Referrer to: ', insightReferrer);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            console.warn('Cannot read referer');
        }
    }

    async function fetchPublicChallenge() {
        return JSON.stringify(await api.getPublicChallenge());
    }

    async function validateChallenge(payload: AltchaVerifiedPayload, solution: string) {
        accessToken.value = await api.validateChallenge(payload, solution);
        axiosInstance.defaults.headers['Authorization'] = buildAuthorizationHeaderValue(accessToken.value);
        return accessToken.value;
    }

    return {
        accessToken,
        setupReferrer,
        fetchPublicChallenge,
        validateChallenge,
    };
});
